import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-[#0A0A0F] text-left">
      <header className="border-b border-[#EAEAE3] bg-white sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Brand />
          <Link to="/" className="flex items-center gap-2 text-sm text-[#5C5C66] hover:text-[#0A0A0F] transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12 lg:py-20">
        <div className="label-mono mb-4 text-[#002FA7]">— Legal Agreement</div>
        <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tight mb-8">Terms of Service</h1>
        <p className="text-sm text-[#5C5C66] mb-12">Last updated: June 9, 2026</p>
        
        <div className="prose prose-slate max-w-none space-y-8 text-sm text-[#5C5C66] leading-relaxed">
          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the LeadsB2B SaaS platform ("Service"), provided by LeadsB2B, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Service.
            </p>
          </section>
          
          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">2. Description of Service</h2>
            <p>
              LeadsB2B provides B2B lead generation, enrichment, email sequence delivery, and pipeline tracking software. We reserve the right to modify or discontinue the Service, or any feature or portion thereof, temporarily or permanently, with or without notice.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">3. Registration and Account Security</h2>
            <p>
              You must register for an account to use the Service. You agree to provide accurate, current, and complete information during registration. You are responsible for safeguarding your password and for all activities that occur under your account. You must immediately notify LeadsB2B of any unauthorized use of your account.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">4. Subscription and Billing Quotas</h2>
            <p>
              Free trial accounts are granted a quota of 50 prospect credits. Once this quota is reached, or the 7-day trial period expires, access to lead generation will be suspended until a subscription is purchased. Subscription fees are billed in advance on a recurring monthly or annual basis. All fees are non-refundable except as required by law.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">5. Acceptable Use and Compliance</h2>
            <p>
              You agree to use the Service in compliance with all applicable laws, including but not limited to CAN-SPAM, GDPR, and other privacy and electronic communication regulations. You are solely responsible for verifying the compliance of your email campaigns and the legitimacy of the contact information generated.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-[#0A0A0F]">6. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, LeadsB2B shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses.
            </p>
          </section>
        </div>
      </main>
      <footer className="border-t border-[#EAEAE3] py-8 text-center text-xs text-[#9A9AA3] bg-white">
        © 2026 LeadsB2B. All rights reserved.
      </footer>
    </div>
  );
}
